/* locale-image-swapper.js — Sccoti — preserves srcset widths during locale swap */
(function(){
  var M = window._imsMap || (window._ims && Object.values(window._ims)[0]) || {};
  // If your existing file has the M map inline, paste it here. Otherwise leaving M empty
  // and reading from window._ims (legacy) preserves backward compat.

  function n(u){
    return (u || "")
      .replace(/^https?:/, "")
      .replace(/^\/\//, "//")
      .split("?")[0];
  }

  function tr(src, loc){
    var m = window._ims && window._ims[loc];
    if (!m) return null;
    var k = n(src);
    if (m[k]) return m[k];
    if (m["https:" + k]) return m["https:" + k];
    var f = k.split("/").pop();
    for (var i in m){ if (n(i).split("/").pop() === f) return m[i]; }
    return null;
  }

  function getWidth(url){
    var m = (url || "").match(/[?&]width=(\d+)/);
    return m ? m[1] : null;
  }

  function withWidth(url, w){
    if (!url || !w) return url;
    url = url.replace(/([?&])width=\d+&?/, "$1").replace(/[?&]$/, "");
    return url + (url.indexOf("?") === -1 ? "?" : "&") + "width=" + w;
  }

  function rewriteSrcset(srcset, loc, fallback){
    return srcset.split(",").map(function(entry){
      var parts = entry.trim().split(/\s+/);
      var url = parts[0];
      var descriptor = parts.slice(1).join(" ");
      var translated = tr(url, loc) || fallback;
      // Width can come from descriptor ("493w") or query param (?width=493)
      var dMatch = descriptor.match(/^(\d+)w$/);
      var w = dMatch ? dMatch[1] : getWidth(url);
      var finalUrl = withWidth(translated, w);
      return descriptor ? finalUrl + " " + descriptor : finalUrl;
    }).join(", ");
  }

  function sw(img, loc){
    var s = img.src || "";
    if (!s || (s.indexOf("cdn.shopify.com") === -1 && s.indexOf("/cdn/shop/files/") === -1)) return;
    var r = tr(s, loc);
    if (r && r !== s){
      img.setAttribute("data-o", s);
      var srcW = getWidth(s);
      img.src = withWidth(r, srcW);
      if (img.srcset){
        img.srcset = rewriteSrcset(img.srcset, loc, r);
      }
    }
    var ds = img.dataset && img.dataset.src;
    if (ds){
      var r2 = tr(ds, loc);
      if (r2 && r2 !== ds){
        var dsW = getWidth(ds);
        img.dataset.src = withWidth(r2, dsW);
      }
    }
  }

  function sa(loc){ var a = document.querySelectorAll("img"); for (var i = 0; i < a.length; i++) sw(a[i], loc); }

  function wd(loc){
    new MutationObserver(function(ms){
      ms.forEach(function(m){
        m.addedNodes.forEach(function(nd){
          if (nd.tagName === "IMG") sw(nd, loc);
          if (nd.querySelectorAll){
            var b = nd.querySelectorAll("img");
            for (var i = 0; i < b.length; i++) sw(b[i], loc);
          }
        });
        if (m.type === "attributes" && m.target.tagName === "IMG") sw(m.target, loc);
      });
    }).observe(document.body || document.documentElement, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ["src", "srcset", "data-src"]
    });
  }

  function init(){
    var loc = (window.Shopify && window.Shopify.locale) || "en";
    if (loc === "en" || !window._ims || !window._ims[loc]) return;
    sa(loc); wd(loc);
    [500, 1500, 3000].forEach(function(d){ setTimeout(function(){ sa(loc); }, d); });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();